/**
 * @ngdoc directive
 * @name flowHistoryWaiting
 * @module flowingly.runner.flow
 * @description This comppnent is used to display information about who a step is waiting on.
 * @usage
 * ```
     <flow-history-waiting ng-if="!step.completed" step="step" is-mobile="$ctrl.isMobile"></flow-history-waiting>
 * ``` 
 * ### Notes
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Angular+Flow+Components
 * ### Properties
 * #### Inputs
 * * step: the step data to display (JSON)
 * * isMobile: show mobile view if set
 */

'use strict';
import angular from 'angular';

angular.module('flowingly.runner.flow').component('flowHistoryWaiting', {
  bindings: {
    step: '<',
    isMobile: '<', //show mobile view if set
    onSelectStep: '&'
  },
  template: `
                <div ng-if="!$ctrl.isMobile" class="flow-history-waiting flex flex-row" ng-class ="{'pt-0': $ctrl.step.actorAssignedAvatarUrl, 'flow-history-waiting--selected': $ctrl.step.isSelectedStep }">
                    <div class="avatar-container">
                        <!-- who contains "You" when logged user is actor. So to get correct avatar initial fullname property is used. But for Group we still need to use who property as username will have current username. -->

                          <div ng-if="$ctrl.step.integrationState == null || $ctrl.step.integrationState.state !== 0">
                             <div class="avatar">
                               <flow-avatar-circle name="$ctrl.step.actorAssignedName" avatar-url="$ctrl.step.actorAssignedAvatarUrl"></flow-avatar-circle>
                             </div>
                          </div>
                         <div ng-if="$ctrl.step.integrationState != null && $ctrl.step.integrationState.state === 0">
                            <div class="avatar step-processing-avatar">
                                <i class="fa-light fa-desktop step-processing-icon"></i>                    
                            </div>
                         </div>    
                    </div>

                    <div class="text single-flow-view__contents current-step-display-moment">
                        <p data-testid="waiting-step-name"><b>{{$ctrl.step.name}}</b></p>

                        <div ng-if="$ctrl.step.integrationState == null || $ctrl.step.integrationState.state !== 0">
                            <div ng-if="$ctrl.step.stepApprovers.length > 0">
                                <p class ="secondary-text" data-testid="waiting-for-message">Waiting for approval by <span data-testid="waiting-for-actor">{{$ctrl.step.whoIsAssignedStep}}</span> for {{$ctrl.step.moment}}</p>
                            </div>
                            <div ng-if="$ctrl.step.stepApprovers.length === 0 || $ctrl.step.stepApprovers === null">
                                <p class ="secondary-text" data-testid="waiting-for-message">Waiting for input by <span data-testid="waiting-for-actor">{{$ctrl.step.whoIsAssignedStep}}</span> for {{$ctrl.step.moment}}</p>
                            </div>
                        </div>

                        <div ng-if="$ctrl.step.integrationState != null && $ctrl.step.integrationState.state === 0">
                            <p class ="secondary-text">Waiting for processing for {{$ctrl.step.integrationState.processingIntegrationMoment}}</p>
                        </div>

                    </div>

                    <div class="text single-flow-view__contents current-step-display-moment-due">
                        <div ng-show="$ctrl.step.isOverdue" class="flow-current-step__contents__due-date__text color-warning flex-column">
                            <i class="fa-light fa-calendar-xmark" aria-hidden="true"></i> {{$ctrl.step.deadLineLabel}}
                        </div>
			            <div ng-show="!$ctrl.step.isOverdue && !$ctrl.flow.isFinalised" class="flow-current-step__contents__due-date__text flex-column">
                            <i class="fa-light fa-calendar-check" aria-hidden="true"></i> {{$ctrl.step.deadLineLabel}}
                        </div>
                        <div class="flow-list__contents__due-date__due-by flex-column">
                            <span ng-show="$ctrl.step.deadLineLabel != 'None'">{{$ctrl.step.momentFinalisedInLocalFormat}}</span>
                        </div>
                    </div>
                </div>

                <div ng-if="$ctrl.isMobile" class="flow-history-waiting isMobile" ng-class ="{'pt-0': $ctrl.step.actorAssignedAvatarUrl, 'flow-history-waiting--selected': $ctrl.step.isSelectedStep }">
                 
                    <div ng-if="$ctrl.step.integrationState == null || $ctrl.step.integrationState.state !== 0">
                        <div class="avatar-container">
                            <div class="avatar">
                                <flow-avatar-circle name="$ctrl.step.actorAssignedName" avatar-url="$ctrl.step.actorAssignedAvatarUrl"></flow-avatar-circle>
                            </div>
                        </div>
                    </div>
                    <div ng-if="$ctrl.step.integrationState != null && $ctrl.step.integrationState.state === 0">
                        <div class="avatar-container">
                           <div class="avatar step-processing-avatar">
                               <i class="fa-light fa-desktop step-processing-icon"></i>                    
                           </div>
                        </div>
                    </div>    

                    <div class="text flow-history-waiting__contents single-flow-view__contents">
                        <p data-testid="waiting-step-name"><b>{{$ctrl.step.name}}</b></p>
                        <div ng-if="$ctrl.step.integrationState == null || $ctrl.step.integrationState.state !== 0">
                                <div ng-if="$ctrl.step.stepApprovers.length > 0">
                                    <p class ="secondary-text" data-testid="waiting-for-message">Waiting for approval by <span data-testid="waiting-for-actor">{{$ctrl.step.whoIsAssignedStep}}</span> for {{$ctrl.step.moment}}</p>
                                </div>
                            <div ng-if="$ctrl.step.stepApprovers.length === 0 || $ctrl.step.stepApprovers === null">
                                <p class ="secondary-text" data-testid="waiting-for-message">Waiting for input by <span data-testid="waiting-for-actor">{{$ctrl.step.whoIsAssignedStep}}</span> for {{$ctrl.step.moment}}</p>
                            </div>
                        </div>
                        <div ng-if="$ctrl.step.integrationState != null && $ctrl.step.integrationState.state === 0">
                            <p class ="secondary-text">Waiting for processing for {{$ctrl.step.integrationState.processingIntegrationMoment}}</p>
                        </div>      
                    </div>
                </div>
            `
});
